export const SAVE_SNIPPET_STARTED = 'SAVE_SNIPPET_STARTED';
export const SAVE_SNIPPET_SUCCESS = 'SAVE_SNIPPET_SUCCESS';
export const SAVE_SNIPPET_FAILURE = 'SAVE_SNIPPET_FAILURE';

export const SHOW_MODAL_SNIPPET = 'SHOW_MODAL_SNIPPET';
export const CLEAR_SNIPPETS = 'CLEAR_SNIPPETS';

export const FETCH_SNIPPETS_SUCCESS = 'FETCH_SNIPPETS_SUCCESS';
export const FETCH_SNIPPETS_FAILURE = 'FETCH_SNIPPETS_FAILURE';

export const STORE_SNIPPET_SUCCESS = 'STORE_SNIPPET_SUCCESS';
export const STORE_SNIPPET_FAILURE = 'STORE_SNIPPET_FAILURE';

export const UPDATE_SNIPPET_SUCCESS = 'UPDATE_SNIPPET_SUCCESS';
export const UPDATE_SNIPPET_FAILURE = 'UPDATE_SNIPPET_FAILURE';

export const DESTROY_SNIPPET_STARTED = 'DESTROY_SNIPPET_STARTED';
export const DESTROY_SNIPPET_SUCCESS = 'DESTROY_SNIPPET_SUCCESS';
export const DESTROY_SNIPPET_FAILURE = 'DESTROY_SNIPPET_FAILURE';

export const SNIPPET_EXISTS_SUCCESS = 'SNIPPET_EXISTS_SUCCESS';
export const SNIPPET_EXISTS_FAILURE = 'SNIPPET_EXISTS_FAILURE';

export const RESET_SNIPPET = 'RESET_SNIPPET';

export const SHOW_MODAL_CONFIRM_SNIPPET = 'SHOW_MODAL_CONFIRM_SNIPPET';
